//---------------------------------------------------------
// Imports
//---------------------------------------------------------
import PersonIcon from '@mui/icons-material/Person';
import StorageIcon from '@mui/icons-material/Storage';
import SettingsIcon from '@mui/icons-material/Settings';
import DescriptionIcon from '@mui/icons-material/Description';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import {Box, IconButton, Tooltip, Typography} from '@mui/material';
import Logo from 'assets/logo/loxi.svg';
import {is_logged_in, move_home} from 'common';
import {t} from 'i18next';
import {Link} from 'react-router-dom';
import package_info from '../../../package.json';
import LanguageIcon from './LanguageIcon';
import Profile from './Profile';
import {useRole} from 'hooks/query/oamHooks';
import {canUseLinodeSettings} from 'pages/soft/linodeUserKeys';

//---------------------------------------------------------
// Functional Component
//---------------------------------------------------------
function InstanceIcon() {
	const return_message = t('Instances');

	return (
		<Tooltip title={return_message} placement="top" arrow>
			<span>
				<IconButton component={Link} to="/instance">
					<StorageIcon sx={{color: 'white'}} fontSize="small" />
				</IconButton>
			</span>
		</Tooltip>
	);
}

function UserIcon() {
	const user_status_message = t('User Management');

	return (
		<Tooltip title={user_status_message} placement="top" arrow>
			<span>
				<IconButton component={Link} to="/user">
					<PersonIcon sx={{color: 'white'}} fontSize="small" />
				</IconButton>
			</span>
		</Tooltip>
	);
}


function SoftAdminIcons() {
	const {is_admin, role} = useRole();
	const showLinode = canUseLinodeSettings(role);
	if (!is_admin && !showLinode) return null;
	return (
		<>
			{is_admin ? (
				<Tooltip title={t('Provision')} placement="top" arrow>
					<span>
						<IconButton component={Link} to="/soft/provision" aria-label={t('Provision')}>
							<CloudUploadIcon sx={{color: 'white'}} fontSize="small" />
						</IconButton>
					</span>
				</Tooltip>
			) : null}
			{is_admin ? (
				<Tooltip title={t('Templates')} placement="top" arrow>
					<span>
						<IconButton component={Link} to="/soft/templates" aria-label={t('Templates')}>
							<DescriptionIcon sx={{color: 'white'}} fontSize="small" />
						</IconButton>
					</span>
				</Tooltip>
			) : null}
			{showLinode ? (
				<Tooltip title={t('Linode')} placement="top" arrow>
					<span>
						<IconButton component={Link} to="/soft/settings/linode" aria-label={t('Linode')}>
							<SettingsIcon sx={{color: 'white'}} fontSize="small" />
						</IconButton>
					</span>
				</Tooltip>
			) : null}
		</>
	);
}

export default function Header() {
	const version = package_info.version;

	const is_enabled = is_logged_in();

	return (
		<Box id="header" width="100%" height="48px" display="flex" alignItems="center" justifyContent="space-between" bgcolor="primary.main" padding="0 16px">
			<Box id="logo" display="flex" alignItems="center" gap="12px">
				<Box width="64px" component="img" src={Logo} alt="logo" onClick={() => move_home()} sx={{cursor: 'pointer'}} />

				<Typography variant="caption" sx={{color: 'rgba(255, 255, 255, 0.65)'}}>
					{`v.${version}`}
				</Typography>
			</Box>

			{is_enabled && (
				<Box id="header-menu" display="flex" gap="20px" alignItems="center">
					<InstanceIcon />
					<SoftAdminIcons />
					<UserIcon />
					<LanguageIcon />
					<Profile />
				</Box>
			)}
		</Box>
	);
}
